import { ViewModel, View } from "binder"
import { MachineTypeEditorView } from "./machineTypeEditor-view"
import { IMachineType } from "../IMachineType";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";

export class MachineTypeEditorViewModel extends ViewModel implements IMachineType, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._serverUpdater = updater;
    }
    GetDefaultView(): View<ViewModel> {
        return new MachineTypeEditorView();
    }
    public getTypeId(): string {
        return "VM-8A77F0AE-ADFD-4E88-9065-CA2D5CA21BD4"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;

    closePopup(result?: any) {

    }

    async cloneTo(machineType: IMachineType) {
        machineType.id = this.id;
        machineType.name = this.name;
        machineType.code = this.code;
    }

    back() {
        this.closePopup(null);
    }

    async save(): Promise<void> {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت نوع ماشین');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this);
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning('امکان ثبت کد نوع ماشین تکراری وجود ندارد.', 'خطا در عملیات');
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('نوع ماشین با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت نوع ماشین', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.name)) {
            result.push('نوع ماشین مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.code)) {
            result.push('کد نوع ماشین مشخص نشده است.');
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(machineType: IMachineType): Promise<any>;
}

export class MachineTypeInserter implements IServerUpdater {
    async execute(machineType: IMachineType): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/MachineTypeServices/CreateMachineType', {
                Name: machineType.name,
                Code: machineType.code
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class MachineTypeUpdater implements IServerUpdater {
    async execute(machineType: IMachineType): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/MachineTypeServices/UpdateMachineType', {
                MachineTypeId: machineType.id,
                Name: machineType.name,
                Code: machineType.code
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}
